import Modal from "react-modal";
import { MainButton } from "../MainButton";
import { toast } from "react-toastify";
import { Slide } from "react-toastify";
import { usePluginspace } from "../../hooks/usePluginspace";

import "./index.css";
import React, {
  useRef,
  ChangeEvent,
  KeyboardEvent,
  FormEvent,
  useState,
} from "react";
import api from "../../services/api";

type NewModalDeliveryProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  code: string;
  setConfirm: (value: boolean) => void;
  backgroundButton?: string;
  fontButton?: string;
  customerId?: string;
  setConfirmValidationRegister: (value: boolean) => void;
};

export function ModalConfirmWpp({
  isOpen,
  setIsOpen,
  code,
  setConfirm,
  backgroundButton,
  fontButton,
  customerId,
  setConfirmValidationRegister,
}: NewModalDeliveryProps) {
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);
  const [error, setError] = useState(false);
  const { getToken, registerAccess, getThisPluginspace } = usePluginspace();

  const handleChange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
    const value = e.target.value;

    if (/^\d$/.test(value)) {
      e.target.value = value;
      if (index < inputsRef.current.length - 1) {
        inputsRef.current[index + 1]?.focus();
      }
    } else {
      e.target.value = "";
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && !e.currentTarget.value && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  const updateCustomerValidation = async () => {
    try {
      setConfirmValidationRegister(true);
      if (customerId) {
        api.put(
          `/api/customer/${customerId}/validate-register`,
          {
            validateRegister: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        );
      } else return;
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      className="modal-confirm-wpp"
      contentLabel="Confirme seu número de telefone"
      overlayClassName="overlay-modal"
      ariaHideApp={false}
    >
      <div className="modal-confirm-wpp-content">
        <div className="modal-confirm-wpp-body">
          <h2>Confirme o código Ninegrid enviado no seu celular</h2>
          <form onSubmit={handleSubmit}>
            <div className="code-input">
              {Array.from({ length: 6 }).map((_, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength={1}
                  pattern="[0-9]*"
                  inputMode="numeric"
                  ref={(el) => (inputsRef.current[index] = el)}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                />
              ))}
            </div>
            {error && <p className="text-error">Código inválido</p>}
            <div className="confirm-wpp-button">
              <MainButton
                color={fontButton ? fontButton : "#636363"}
                backgroundColor={"transparent"}
                border={
                  backgroundButton
                    ? `1px solid ${backgroundButton}`
                    : "1px solid #EAEAEA"
                }
                text="Cancelar"
                onClick={() => {
                  setIsOpen(false);
                }}
              />
              <MainButton
                color={fontButton ? fontButton : "#636363"}
                backgroundColor={
                  backgroundButton ? backgroundButton : "#EAEAEA"
                }
                text="Confirmar"
                onClick={() => {
                  const codeInput = inputsRef.current
                    .map((input) => input?.value || "")
                    .join("");
                  if (codeInput === code) {
                    updateCustomerValidation();
                    setError(false);
                    setConfirm(true);
                    toast.success("WhatsApp confirmado com sucesso!", {
                      position: "top-center",
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: false,
                      draggable: false,
                      progress: undefined,
                      theme: "light",
                      transition: Slide,
                    });
                    setIsOpen(false);
                  } else setError(true);
                }}
              />
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
